export const abbriDict = {
  bitcoin: "BTC",
  ethereum: "ETH",
  tether: "USDT",
  ripple: "XRP",
  "bitcoin cash": "BCH",
  "bitcoin sv": "BSV",
  "binance coin": "BNB",
  "basic attention token": "BAT",
  cardano: "ADA",
  verge: "XVG",
  monero: "XMR",
  "stellar lumens": "XLM",
  nem: "XEM",
  vechain: "VET",
  uniswap: "UNI",
  tron: "TRX",
  theta: "THETA",
  storj: "STORJ",
  steem: "STEEM",
  siacoin: "SC",
  augur: "REP",
  qtum: "QTUM",
  polymath: "POLY",
  perlin: "PERL",
  ontology: "ONT",
  omisego: "OMG",
  "pundi x": "PUNDIX",
  neo: "NEO",
  nano: "NANO",
  "matic network": "MATIC",
  litecoin: "LTC",
  lisk: "LSK",
  chainlink: "LINK",
  aave: "AAVE",
  miota: "IOTA",
  "icon x": "ICX",
  golem: "GLM",
  "fetch.ai": "FET",
  "ethereum classic": "ETC",
  eos: "EOS",
  enjin: "ENJ",
  dogecoin: "DOGE",
  digibyte: "DGB",
  decred: "DCR",
  dash: "DASH",
  bittorrent: "BTT",
  "bitcoin gold": "BTG",
  zcash: "ZEC",
  zilliqa: "ZIL",
  "0x protocol": "ZRX",
  polkadot: "DOT",
  symbol: "XYM",
  "SHIB INU": "SHIB",
};
